import React from "react";

const Loading = (props) => {
  console.log(props.height);
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: props.height,
      }}
    >
      <div className="custom-spinner" role="status">
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  );
};

export default Loading;
